import { useMemo } from 'react'
import { MALDIVES_BUNDLE_DEFAULT_GUESTS } from 'constants/charterFlight'

export interface CharterBundlePricingInput {
  price?: number
  memberPrice?: number
  value?: number
  discountPercent?: number
  totalGuests: number
  roomCount?: number
}

export interface CharterBundlePricingResult {
  displayPrice: number | undefined
  memberDisplayPrice: number | undefined
  valuePrice: number | undefined
  discountPercentage: number | undefined
  guestCount: number
  showMemberPricing: boolean
}

export default function useCharterBundlePricing(
  input: CharterBundlePricingInput,
  isPricePerPerson?: boolean,
): CharterBundlePricingResult {
  const { price, memberPrice, value, discountPercent, totalGuests } = input
  return useMemo(() => {
    const guestCount = totalGuests || MALDIVES_BUNDLE_DEFAULT_GUESTS
    const displayPrice = isPricePerPerson && price
      ? price / guestCount
      : price
    const memberDisplayPrice = isPricePerPerson && memberPrice
      ? memberPrice / guestCount
      : memberPrice
    const valuePrice = isPricePerPerson && value
      ? value / guestCount
      : value
    const showMemberPricing = !!(memberDisplayPrice && displayPrice && memberDisplayPrice < displayPrice)

    return {
      displayPrice,
      memberDisplayPrice,
      valuePrice,
      discountPercentage: discountPercent,
      guestCount,
      showMemberPricing,
    }
  }, [price, memberPrice, value, discountPercent, totalGuests, isPricePerPerson])
}
